// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".assets-tag-table td[data-v-c2224a8e]{padding:0 15px}", ""]);
// Exports
module.exports = exports;
